import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ship4',
  templateUrl: './ship4.component.html',
  styleUrls: ['./ship4.component.css']
})
export class Ship4Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
